import * as Sentry from '@sentry/react';

import {
  GET_SERVICE_DATA_FAILURE,
  GET_SERVICE_DATA_REQUEST,
  GET_SERVICE_DATA_SUCCESS,
  GET_TIMEZONES_DATA_FAILURE,
  GET_TIMEZONES_DATA_REQUEST,
  GET_TIMEZONES_DATA_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  TOGGLE_IS_NAVIGATION_SHOWN,
} from '../../actionConstants';

import {
  isAdmin,
  isPM,
  loadUser,
  saveServiceData,
  saveTimezonesData,
  saveUser,
} from '../../utils';
import { findPersonEmail, findPersonPhoneNumber } from '../Person/utils';
import { setGAUser } from '../Shared/utils/ga';
import { getAllCurrentUserPropertiesIds } from '../User/utils';

import { FLOW_BUILDINGS_IDS } from '../Building/constants';
import { ACCESS_LEVELS } from './constants';

import apiClient from '../../apiClient';
import { history } from '../../store';

export const toggleIsNavigationShown = (dispatch, isNavigationShown) =>
  dispatch({
    type: TOGGLE_IS_NAVIGATION_SHOWN,
    isNavigationShown,
  });

export const getServiceData = (dispatch) =>
  dispatch({
    type: GET_SERVICE_DATA_REQUEST,
    payload: apiClient.aux.getService().then(
      (res) => {
        saveServiceData(res?.data || {});
        return dispatch({
          type: GET_SERVICE_DATA_SUCCESS,
          res,
        });
      },
      (err) =>
        dispatch({
          type: GET_SERVICE_DATA_FAILURE,
          err,
        }),
    ),
  });

export const getTimezonesData = (dispatch) =>
  dispatch({
    type: GET_TIMEZONES_DATA_REQUEST,
    payload: apiClient.aux.getTimezones().then(
      (res) => {
        saveTimezonesData(res?.data || {});
        return dispatch({
          type: GET_TIMEZONES_DATA_SUCCESS,
          res,
        });
      },
      (err) =>
        dispatch({
          type: GET_TIMEZONES_DATA_FAILURE,
          err,
        }),
    ),
  });

export const getUserInfo = (dispatch, redirectToAfterLogin) =>
  dispatch({
    type: GET_USER_REQUEST,
    payload: apiClient.auth.current().then(
      async (res) => {
        dispatch({
          type: GET_USER_SUCCESS,
          res,
        });
        await getServiceData(dispatch);
        getTimezonesData(dispatch);
        toggleIsNavigationShown(dispatch, true);

        const user = res?.data || {};
        saveUser(user);
        setGAUser(user);
        Sentry.configureScope((scope) => {
          scope.setUser({
            firstName: user.firstName,
            lastName: user.lastName,
            id: user.id,
            phoneNumber: findPersonPhoneNumber(user),
            email: findPersonEmail(user),
          });
        });

        const isCCAgent = user?.isService;
        if (redirectToAfterLogin || isCCAgent) {
          const redirectUrl =
            isCCAgent &&
            redirectToAfterLogin?.includes('/call-center-dashboard')
              ? redirectToAfterLogin
              : isCCAgent
              ? '/call-center-dashboard'
              : redirectToAfterLogin;
          history.push(redirectUrl, { from: '/login' });
        }
        return res;
      },
      (err) =>
        dispatch({
          type: GET_USER_FAILURE,
          err,
        }),
    ),
  });

export const checkMenuItemAccess = (item) => {
  switch (item) {
    case ACCESS_LEVELS.ALL:
      return false;
    case ACCESS_LEVELS.ADMIN:
      return !isAdmin();
    case ACCESS_LEVELS.PM:
      return !isPM();
    default:
      return true;
  }
};

export const placeholder = 'placeholder';

export const getIsCommunityShown = () =>
  isAdmin() || loadUser()?.communities?.length > 0;

export const getIsManagementCompanyShown = () =>
  loadUser()?.pmcRoles?.length > 0;

export const getIsEventsShown = () => {
  const currentUserPropertiesIds = getAllCurrentUserPropertiesIds();
  const hasFlowPropertyAccess = !!FLOW_BUILDINGS_IDS.find((id) =>
    currentUserPropertiesIds.includes(id),
  );
  return hasFlowPropertyAccess;
};
